import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import SubscriptionForm from './SubscriptionForm';

function Footer() {

    return (
        <>
            
            <Row className="" style={{ borderTop: '4px solid #d2b521', backgroundColor: '#0f244a' }}>
                <Container className="my-4 py-4">
                    <div className="mt-4 mb-4 pb-4 pt-2 container">
                        <SubscriptionForm 
                            titleColor="#212529"
                            textColor="#212529"
                            subscribedTextColor="#d2b521"
                        />
                    </div>
                </Container>
            </Row>
            <footer className="footer text-white py-3">
                <Container className="py-5">
                    <Row className="justify-content-between align-content-start footer-content">
                        <Col md={2}>
                            <a href="/"> <img className="logo" src="/images/qgold-logo.png" alt="Q Gold logo" /></a>
                        </Col>
                        <Col md={3}>
                            <div>
                                <h4>Address</h4>
                                <p> Q-Gold Resources Ltd. <br />
                                    198 Davenport Road, Toronto, ON M5R 1J2</p>
                                <div className="mt-0">
                                    <a href="https://www.facebook.com/qgold.resources.ltd/" target="_blank" rel="noopener noreferrer" className="me-3">
                                        <img src="/images/facebook.svg" alt="Facebook" style={{ height: '16px', width: '16px' }} />
                                    </a>
                                    <a href="https://x.com/qgold_ltd" target="_blank" rel="noopener noreferrer" className="me-3">
                                        <img src="/images/x.svg" alt="Twitter/X" style={{ height: '16px', width: '16px' }} />
                                    </a>
                                    <a href="https://www.linkedin.com/company/q-gold-resources-ltd/" target="_blank" rel="noopener noreferrer">
                                        <img src="/images/linkedin.svg" alt="LinkedIn" style={{ height: '16px', width: '16px' }} />
                                    </a>
                                </div>
                            </div>
                        </Col>
                        <Col md={3}>
                            <h4>Contact</h4>
                            <a href="mailto:info@qgoldresources.com">info@qgoldresources.com
                            </a>

                        </Col>
                        <Col md={3}>
                            <h4>Legal</h4>
                            <a href="/legal-notice">Legal Notice</a>

                        </Col>
                    </Row>

                    <Row className="justify-content-between d-flex pt-3 small-txt">
                        <Col md={6}>
                            <p> © {new Date().getFullYear()} Q-Gold Resources Ltd. All rights reserved.</p>
                        </Col>
                        <Col md={6}>
                            <p className="text-right"> Powered & Protected by <a href="https://www.armadaws.com/" target="_blank">Armada Web
                                Solutions</a></p>
                        </Col>
                    </Row>

                </Container>
            </footer>
        </>
    );
}

export default Footer;
